<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppFooter from '@stl/v2/components/AppFooter.vue';
import AppHeader from '@stl/v2/components/AppHeader.vue';
import AppLoader from '@stl/v2/components/AppLoader.vue';
import AppMain from '@stl/v2/components/AppMain.vue';
import { useTheme } from '@stl/stores/theme';
import AppUpdateBanner from '@stl/components/AppUpdateBanner.vue';
import { useVersion } from '@stl/stores/version';
import RegisterDevice from '@/components/RegisterDevice.vue';
import EditDevice from '@/components/EditDevice.vue';
import { useUser } from '@/composables/user';

const theme = useTheme();
const route = useRoute();
const isBlankLayout = computed(() => route.meta.layout === 'blank');

// Destructuring unwraps `apiVersion` to the string held at setup, and it is filled
// in later from the API-Version response header, so the footer never updated.
// `version` is a build-time env constant on the store, not a ref.
const versionStore = useVersion();
const version = versionStore.version;
const apiVersion = computed(() => versionStore.apiVersion);

const { isLoadingUser, user: currentUser } = useUser();

const authDomain = import.meta.env.VITE_EDGE_AUTH_DOMAIN;
const logoutUrl = `https://${authDomain}/logout`;

const user = computed(() => {
  if (currentUser.value) {
    return {
      username: currentUser.value.username,
      email: ''
    };
  }
  return null;
});
</script>

<template lang="pug">
BApp
  BOrchestrator
  template(v-if="isLoadingUser")
    AppLoader
  template(v-else-if="isBlankLayout")
    RouterView
  template(v-else)
    AppUpdateBanner(app-name="registry dashboard")
    AppHeader(title="HSDP VPN" :user="user" :logout-url="logoutUrl")
      template(#brand)
        img(v-if="theme.isDark" height="32" src="@stl/v2/assets/images/edge-simple-dark.png" alt="Philips Edge")
        img(v-else height="32" src="@stl/v2/assets/images/edge-simple-light.png" alt="Philips Edge")
    AppMain
      template(#default)
        RouterView
      template(#overlays)
        RegisterDevice
        EditDevice
    AppFooter(:version="version" :api-version="apiVersion")
</template>
